import { FiMenu } from "react-icons/fi";
import { IconButton, Button, Flex, Text, Spacer } from "@chakra-ui/react";
import { useSidenav } from "./SidenavContext";
import React from 'react';
import LogoutButton from '../../buttons/LogoutButton';
import { useTranslation } from 'react-i18next';
import { FaVolumeUp, FaVolumeMute } from "react-icons/fa";
import { useSound } from '../../../pages/SoundContext.jsx'; // or wherever you put it

export function NavBar2() {
    const { t } = useTranslation();
    const { onOpen } = useSidenav();
    const { soundEnabled, toggleSound } = useSound();

    return (
        <Flex as="nav" p="10px" alignItems="center" bg="orange.100">
            <IconButton
                bg="orange.100"
                aria-label="menu"
                display={{ base: "flex", md: "none" }}
                onClick={onOpen}
                icon={<FiMenu />}
            />

            <Text as='b' fontSize="2xl">{t('text_villa_rhapsody')}</Text>

            <Spacer />
            <Text as='b' fontSize="xl" mr="4"> Support Hotline: +852 5423 7656</Text>
            <Button
                onClick={toggleSound}
                leftIcon={soundEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
                colorScheme={soundEnabled ? "green" : "red"}
                variant="solid"
                size="md"
                mr="2"
            >
                {soundEnabled ? t("text_sound_on") : t("text_sound_off")}
            </Button>

            <LogoutButton>{t('text_logout')}</LogoutButton>
        </Flex>
    );
}